<template>
  <span>{{ $t('verifyEmail') }}.
    {{ $t("emailNotRecieved") }}?
    <a href="#" @click="resendVerification">
      {{ $t('resend') }}
    </a>
  </span>
</template>

<script>
import RecaptchaMixin from '../mixins/RecaptchaMixin';
import User from '../orm/models/User/User';

export default {
  name: 'VerifyEmailBar',
  mixins: [RecaptchaMixin],
  methods: {
    async resendVerification() {
      try {
        const recaptchaToken = await this.getRecaptchaToken('userResendVerification');
        await User.api().verifyEmailResend({ recaptchaToken });
        this.$toast.info(this.$t('verificationEmailSent'), { y: 'top' });
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  verifyEmail: Verify your e-mail address
  emailNotRecieved: E-mail not received
  resend: Resend
  verificationEmailSent: Verification e-mail was sent
</i18n>

<i18n locale="ru" lang="yaml">
  verifyEmail: Подтвердите свой e-mail адрес
  emailNotRecieved: Не пришло письмо
  resend: Отправить еще раз
  verificationEmailSent: Письмо для подтверждения E-mail отправлено
</i18n>
